import Vue from 'vue';
export default Vue.extend({
    name: 'spotAvailableCoin',
    props: {
        name: {
            type: String,
            required: true
        },
        selected: {
            type: Boolean,
            required: true
        },
        isAvailableCoin: {
            type: Boolean,
            required: true
        }
    }
});
